import { fetchIncomingOrdersByDate, fetchTodaysIncomingOrders, fetchTotalPurchases, fetchPurchaseOrdersNotReceived, fetchPurchaseOrders, selectPurchaseOrder, resetCurrentPurchaseOrder, fetchPurchasePaymentNotPaid } from '../../actions/purchaseOrders_actions';
import { fetchInventories, selectInventory, resetCurrentInventory } from '../../actions/inventories_actions';
import { fetchFavorites, selectFavorites, resetCurrentFavorites, deleteFavorite } from '../../actions/favorites_actions';
import { fetchNumPurchaseQuotes } from '../../actions/purchaseQuotes_actions';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { resetCurrentPurchaseReturn } from '../../actions/purchaseReturns_actions';

import PurchaseDashboard from '../../components/Purchase/purchaseDashboard'

let purchaseDashboard = reduxForm({
    form: 'purchaseDashboard',
})(PurchaseDashboard);

const selector = formValueSelector('purchaseDashboard');

function mapStateToProps(state) {
    const dateChosen = selector(state, 'SelectedDate');

    return {
        dateChosen,

        todaysIncomingOrders: state.purchaseOrders.todaysIncomingOrders,
        todaysIncomingOrdersIsLoading: state.purchaseOrders.todaysIncomingOrdersIsLoading,
        todaysIncomingOrdersError: state.purchaseOrders.todaysIncomingOrdersError,

        // To be removed
        currentPurchaseOrder: state.purchaseOrders.currentPurchaseOrder,
        purchaseOrders: state.purchaseOrders.all,
        POIsLoading: state.purchaseOrders.isLoading,
        POError: state.purchaseOrders.error,
        // end here

        inventories: state.inventories.all,
        favorites: state.favorites.all,
        inventoryIsLoading: state.inventories.isLoading,
        favoritesAreLoading: state.favorites.isLoading,
        inventoryError: state.inventories.error,
        favoritesError: state.favorites.error,
        currentInventory: state.inventories.currentInventory,
        currentFavorites: state.favorites.currentFavorites,

        numPurchaseQuotes: state.purchaseQuotes.numPurchaseQuotes,
        numPurchaseQuotesLoading: state.purchaseQuotes.numPurchaseQuotesLoading,
        numPurchaseQuotesError: state.purchaseQuotes.numPurchaseQuotesError,
        numPurchaseOrdersNotReceived: state.purchaseOrders.numPurchaseOrdersNotReceived,
        numPurchaseOrdersNotReceivedLoading: state.purchaseOrders.numPurchaseOrdersNotReceivedLoading,
        numPurchaseOrdersNotReceivedError: state.purchaseOrders.numPurchaseOrdersNotReceivedError,
        numTotalPurchases: state.purchaseOrders.numTotalPurchases,
        numTotalPurchasesError: state.purchaseOrders.numTotalPurchasesError,
        numTotalPurchasesLoading: state.purchaseOrders.numTotalPurchasesLoading,
        numPurchaseOrdersNotPaid: state.purchaseOrders.numPurchaseOrdersNotPaid,
        numPurchaseOrdersNotPaidLoading: state.purchaseOrders.numPurchaseOrdersNotPaidLoading,
        numPurchaseOrdersNotPaidError: state.purchaseOrders.numPurchaseOrdersNotPaidError,


    };
}

export default connect(mapStateToProps, { fetchPurchaseOrders, selectPurchaseOrder, resetCurrentPurchaseOrder,
                                            fetchInventories, fetchFavorites, selectInventory, selectFavorites,
                                             resetCurrentInventory, resetCurrentFavorites, deleteFavorite,
                                              fetchNumPurchaseQuotes, fetchPurchaseOrdersNotReceived, fetchTotalPurchases,
                                               fetchTodaysIncomingOrders, fetchIncomingOrdersByDate, resetCurrentPurchaseReturn, fetchPurchasePaymentNotPaid })(purchaseDashboard);



// WEBPACK FOOTER //
// ./master/jsx/containers/Purchase/purchaseDashboard.jsx